
import { logEvent } from "firebase/analytics";
import { analytics } from "./FirebaseConfig";

export enum AnalyticsKeys {
  ForStadiumOwner = 'For_Stadium_Owners',
  CompleteSignUp = "Complete_Sign_up"
}

class FirebaseAnalytics {

  log = (value) => {
    logEvent(analytics, value)
  }

}

export default new FirebaseAnalytics()